const BotAuth = () => import('@/views/bot/components/BotAuth')

export default [
  {
    name: 'bot.auth',
    path: '/bot/login',
    component: BotAuth,
    meta: {
      requiresAuth: false,
      allowAuthenticated: true,
    },
  }
]
